import axios from "axios";

const api = axios.create({
  // baseURL: "https://api.syfactory.xyz/" ,
  baseURL: "/",
  headers: { "Content-Type": "application/json" },
});
export default api;
